export default __webpack_public_path__ + "../staticImages/safari-pinned-tab.svg";